$(function(){
    function initCarousel(){
        const swiper = new Swiper('.swiper-container', {
            // Optional parameters
            // direction: 'vertical',
            loop: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 30,
            loopedSlides: 3,
            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            
            autoplay: {
                delay : 4000
            },
            // Navigation arrows
            navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                651: {
                    centeredSlides: false,
                    spaceBetween: 30,
                    slidesPerView: 3,
                }
            },
        });
    }

    function initMenu(){
        const $target = $('.js-tc-target')
        const activeClass = "js-active";

        $('.js-tc-toggle').on('click', function(){
            $(this).toggleClass(activeClass)
            $target.toggleClass(activeClass)
        })
    }


    initCarousel()
    initMenu()
    $('.js-accordion').aemAccordion()

    $(".modal--inline .modal__thumb img").on("touchstart", function(e){
        e.stopPropagation();
    })
});
